import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
app.initializers.add('hustab-media-access', () => {
  const canManage = () => !!app.forum.attribute('hustabCanManageMedia');
  extend('flarum/common/components/TextEditor', 'controlItems', function (items) {
    if (!canManage()) items.remove('fof-upload-media');
  });
  extend('flarum/forum/components/UserPage', 'navItems', function (items) {
    if (!canManage()) items.remove('uploads');
  });
}, -100);